<template>
  <div class="text-center task__btn__group" :class="roleClass">
    <div
      class="tabs-mobile hideOnBigSize"
      :class="[roleClass, { 'tabs-mobile--equal': mobileEqual }]"
      :style="mobileTabsStyle"
    >
      <button
        v-for="tab in visibleTabs"
        :key="`mobile-${tab.value}`"
        type="button"
        class="tab-btn"
        :class="{ active: modelValue === tab.value }"
        :disabled="Boolean(tab.disabled)"
        @click="emitTab(tab)"
      >
        <span>{{ getMobileLabel(tab) }}</span>
        <span v-if="Number(tab.badge || 0) > 0" class="tab-badge">{{ Number(tab.badge) }}</span>
      </button>
    </div>

    <div class="hideOnSmallSize switch-btn-group-big" :class="roleClass">
      <div class="tabs-desktop">
        <button
          v-for="tab in visibleTabs"
          :key="`desktop-${tab.value}`"
          type="button"
          class="switch-btn-big"
          :class="{ active: modelValue === tab.value }"
          :disabled="Boolean(tab.disabled)"
          @click="emitTab(tab)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="Number(tab.badge || 0) > 0" class="tab-badge">{{ Number(tab.badge) }}</span>
        </button>
      </div>
      <slot name="desktop-extra" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  tabs: {
    type: Array,
    default: () => [],
  },
  roleClass: {
    type: String,
    default: "",
  },
  mobileEqual: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "tab-click"]);

const visibleTabs = computed(() =>
  props.tabs.filter((tab) => tab && tab.visible !== false)
);

const mobileTabsStyle = computed(() => ({
  '--mobile-tabs-count': String(Math.max(visibleTabs.value.length || 1, 1)),
}));

function getMobileLabel(tab) {
  return tab?.shortLabel || tab?.mobileLabel || tab?.label || "";
}

function emitTab(tab) {
  if (!tab || tab.disabled) return;
  emit("tab-click", tab);
  emit("update:modelValue", tab.value);
}
</script>

<style scoped lang="scss">
.task__btn__group {
  background-color: #f5f6f7;
  z-index: 100;
  margin: 0;
}

.tabs-mobile,
.tabs-desktop {
  display: flex;
  align-items: center;
  height: 72px;
  overflow: hidden;
  margin-left: 260px;
}
.tabs-desktop {
  border-top: 1px solid #e0e0e0;
}
.tabs-mobile {
  margin-left: 0;
  margin-top: 0;
  margin-bottom: 0;
  height: 54px;
}

.tab-btn,
.switch-btn-big {
  background: none;
  border: none;
  color: #8b8b8d;
  font-size: 18px;
  min-width: 168px;
  height: 72px;
  padding: 0 24px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.tabs-mobile .tab-btn {
  min-width: 120px;
  font-size: 14px;
  height: 54px;
}

.tab-btn.active,
.switch-btn-big.active {
  color: #18191f;
  font-weight: 500;
  background: #ffffff;
}

.tab-btn:disabled,
.switch-btn-big:disabled {
  opacity: 0.45;
  cursor: default;
}

.switch-btn-group-big {
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
}

.tab-badge {
  min-width: 18px;
  height: 16px;
  border-radius: 10px;
  background: #eb5757;
  color: #fff;
  font-size: 10px;
  line-height: 16px;
  padding: 0 5px;
  font-weight: 500;
  position: relative;
  top: -8px;
  left: -4px;
}

@media screen and (min-width: 768px) {
  .task__btn__group {
    position: fixed;
    left: 0;
    right: 0;
    top: 56px;
    height: 72px;
    margin: 0 5% 0 15%;
    max-width: 1350px;
  }

  .switch-btn-group-big {
    position: fixed;
    left: 0;
    right: 0;
    top: 56px;
    height: 72px;
    margin: 0 5% 0 15%;
    max-width: 1350px;
    background: #f5f6f7;
    z-index: 3;
  }
}

@media screen and (max-width: 767px) {
  .task__btn__group {
    height: 54px;
  }

  .task__btn__group.active-parent {
    background-color: #1c3043;
  }

  .task__btn__group.active-pupil {
    background-color: #164922;
  }

  .tabs-mobile.hideOnBigSize {
    width: 100%;
    display: grid !important;
    grid-template-columns: repeat(var(--mobile-tabs-count, 1), minmax(0, 1fr));
    align-items: stretch;
  }

  .tab-btn {
    background: transparent;
    color: rgba(255, 255, 255, 0.72);
    min-width: 0;
    width: 100%;
    max-width: 100%;
    flex: 0 0 auto;
    padding: 0 8px;
    margin: 0;
    overflow: hidden;
  }

  .tab-btn span:first-child {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tab-btn.active {
    background: transparent;
    color: #ffffff;
    font-weight: 500;
  }

  .tabs-mobile.active-parent .tab-btn.active {
    // box-shadow: 0 -3px 0 #00c2ff inset !important;
    border-bottom: 4px solid #00c2ff;
  }

  .tabs-mobile.active-pupil .tab-btn.active {
    // box-shadow: 0 -3px 0 #36b453 inset !important;
    border-bottom: 4px solid #36b453;
  }

  .tabs-mobile--equal .tab-btn {
    padding: 0 6px;
    font-size: 13px;
  }
}
</style>
